export default {"src":"/_next/static/media/countdown_background_2.9b14e4ad.svg","height":60,"width":169,"blurWidth":0,"blurHeight":0};